export default class CreateMarkerModel {
    assetId = null;
    scanId = null;
    transform = null;
    label = null;
    markerTypeId = null;
    isAiGenerated = false;
    inspectionAreaId = null;

    constructor(assetId, label, isAiGenerated, positionX, positionY, positionZ, inspectionAreaId = null, scanId = null, markerTypeId = null){
        this.assetId = assetId;
        this.scanId = scanId;
        this.label = label;
        this.markerTypeId = markerTypeId;
        this.isAiGenerated = isAiGenerated;
        this.inspectionAreaId = inspectionAreaId;

        this.transform = {
            position: {
                x: positionX || 0,
                y: positionY || 0,
                z: positionZ || 0,
              },
              scale: {
                x: 1,
                y: 1,
                z: 1,
                order: "XYZ",
                isEuler: false
              },
              rotation: {
                x: 0,
                y: 0,
                z: 0,
              },
        };
    }
}